export const massCampaignCandidateStoreKey = 'massCampaignCandidate';
